/**
 * Created by harris on 17-2-18.
 */
import AppConfig from 'src/config'
import * as Util from './Util'
import Net from './Net'

let ua = window.navigator.userAgent,  // 客户端的信息
matched = ua.match(/MicroMessenger/i);

// 判断是否是微信环境，如果是debug模式的话，则默认为微信，如果不是，则需要进行判断
export const isWeixin = DEBUG ? true : matched && matched[0] && matched[0].toLowerCase() == 'micromessenger';

let _promises = [Promise.resolve(1)];  // Promise 对象用于异步计算
if (isWeixin && !window.wx) {  // 如果是微信，则需要引入微信的JS文件
  _promises.push(Util.loadJS(AppConfig.wx.defaultSDK));
}

let url = window.location.href.split('#')[0];
export const ready = function () {
  if (isWeixin) {
    if (Util.os.isAndroid) {
       url = window.location.href.split("#")[0];
    }

    // 创建一个承诺，Promise.all是当所有给定的可迭代完成时执行 resolve，或者任何  promises 失败时执行 reject。
    // 在这里是指微信js的加载，和微信的授权
    return Promise.all([].concat(_promises, Net.WeixinAuth({url}))).then(function (result) {
      // 微信登录授权成功之后开始执行下面的程序
      let {data} = result[result.length - 1];
      const wx = window.wx;

      if (DEBUG) {
        console.log(data);
      }
      // 微信公众号接口权限的注入
      wx.config({
//        debug: true,
        jsApiList: AppConfig.wx.jsApiList,
        ...data
      });
      // 再次创建一个承诺，微信权限注入成功之后，所有接口都必须得在ready下面执行
      return new Promise(function (resolve, reject) {
        wx.ready(function () {
          resolve(wx);
        });

        wx.error(reject);

      })
    })
  }
};

//防止重复初始化，在明确页面初始化过的情况下，可以直接调用此方法获取微信对象
export const getInstance = function () {
  return window.wx;
}




// WEBPACK FOOTER //
// ./src/lib/Wx.js